import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import UncontrolledDefaultModal from 'components/Modal/UncontrolledDefaultModal';
import { FlexControllerV2 } from 'components/FlexControllerInput/V2';
import { Button, Row, Col } from 'reactstrap';

const ManagePauseModal = React.memo(
  ({ login, pauseId, pausesOptions, pauseAgent, unpauseAgent }) => {
    const systemConfiguration = useSelector(
      (state) => state.systemConfiguration
    );
    const { handleSubmit, control, errors } = useForm();

    const isPaused = !!pauseId;

    const onPauseSubmit = useCallback(
      (data) => {
        const selectedPauseId = data.pause?.value;
        if (!selectedPauseId) {
          toast.warn('Por favor, selecione um motivo de pausa.');
          return;
        }

        pauseAgent({ login, pauseId: selectedPauseId })
          .then(() => toast.success('Agente pausado com sucesso'))
          .catch((err) =>
            toast.error(
              err?.response?.data?.message ?? 'Falha ao pausar o agente'
            )
          );
      },
      [login, pauseAgent]
    );

    const onUnpauseClick = useCallback(() => {
      unpauseAgent({ login })
        .then(() => toast.success('Agente despausado com sucesso'))
        .catch((err) =>
          toast.error(
            err?.response?.data?.message ?? 'Falha ao despausar o agente'
          )
        );
    }, [login, unpauseAgent]);

    if (isPaused) {
      return (
        <Button
          color="warning"
          size="sm"
          title="Despausar este atendente"
          onClick={onUnpauseClick}
        >
          <li className="fas fa-play-circle"></li>
        </Button>
      );
    }

    return (
      <UncontrolledDefaultModal
        trigger={
          <Button color="info" size="sm" title="Pausar este atendente">
            <li className="fas fa-pause-circle"></li>
          </Button>
        }
        header="Pausar Atendente"
        title="Pausar Atendente"
        subtitle="Selecione o motivo e pause o atendente."
        body={
          <Row style={{ paddingInline: '1rem' }}>
            <Col md="12">
              <form onSubmit={handleSubmit(onPauseSubmit)}>
                <Row
                  className="align-items-center no-gutters"
                  style={{ gap: '0.5rem' }}
                >
                  <Col>
                    <FlexControllerV2
                      type="select"
                      name="pause"
                      control={control}
                      options={pausesOptions}
                      errors={errors}
                      rules={{ required: 'Campo obrigatório' }}
                    />
                  </Col>
                  <Col xs="auto">
                    <Button color="primary" type="submit">
                      Pausar
                    </Button>
                  </Col>
                </Row>
              </form>
            </Col>
          </Row>
        }
        footer={({ closeModal }) => (
          <div
            className="modal-footer"
            style={{ paddingTop: '.5rem', paddingInline: '.75rem' }}
          >
            <Button
              type="button"
              color="danger"
              style={{
                backgroundColor: systemConfiguration.cancelation_button_color
              }}
              onClick={closeModal}
            >
              Fechar
            </Button>
          </div>
        )}
      ></UncontrolledDefaultModal>
    );
  }
);

export default ManagePauseModal;
